import React from 'react';

const FILTER_PILL_COUNT = 6;
const SKELETON_CARD_COUNT = 8;

function SkeletonBlock({ className = '', ...props }) {
  return <span className={`menu-skeleton ${className}`.trim()} aria-hidden {...props} />;
}

function FilterSkeleton() {
  return (
    <div className="menu-filter menu-skeleton-filters" aria-hidden>
      {Array.from({ length: FILTER_PILL_COUNT }, (_, i) => (
        <SkeletonBlock key={i} className="menu-skeleton--pill" />
      ))}
    </div>
  );
}

function GridCardSkeleton() {
  return (
    <div className="menu-card menu-skeleton-card" aria-hidden>
      <SkeletonBlock className="menu-skeleton--card-img" />
      <div className="menu-card__body">
        <SkeletonBlock className="menu-skeleton--line menu-skeleton--line-title" />
        <SkeletonBlock className="menu-skeleton--line menu-skeleton--line-desc" />
        <SkeletonBlock className="menu-skeleton--line menu-skeleton--line-desc menu-skeleton--line-desc-short" />
        <div className="menu-skeleton-card__footer">
          <SkeletonBlock className="menu-skeleton--line menu-skeleton--line-price" />
          <SkeletonBlock className="menu-skeleton--btn" />
        </div>
      </div>
    </div>
  );
}

function ListCardSkeleton() {
  return (
    <div className="menu-list-item menu-skeleton-card menu-skeleton-card--list" aria-hidden>
      <SkeletonBlock className="menu-skeleton--list-img" />
      <div className="menu-card__body">
        <SkeletonBlock className="menu-skeleton--line menu-skeleton--line-title" />
        <SkeletonBlock className="menu-skeleton--line menu-skeleton--line-desc" />
        <div className="menu-skeleton-card__footer">
          <SkeletonBlock className="menu-skeleton--line menu-skeleton--line-price" />
          <SkeletonBlock className="menu-skeleton--btn" />
        </div>
      </div>
    </div>
  );
}

function CompactRowSkeleton() {
  return (
    <div className="menu-compact__row menu-skeleton-compact-row" aria-hidden>
      <SkeletonBlock className="menu-skeleton--compact-img" />
      <SkeletonBlock className="menu-skeleton--line menu-skeleton--line-compact-name" />
      <SkeletonBlock className="menu-skeleton--line menu-skeleton--line-compact-price" />
      <SkeletonBlock className="menu-skeleton--compact-btn" />
    </div>
  );
}

function MenuBodySkeleton({ view }) {
  if (view === 'compact') {
    return (
      <div className="menu-skeleton-body" aria-hidden>
        <div className="menu-compact menu-skeleton-compact">
          {Array.from({ length: SKELETON_CARD_COUNT }, (_, i) => (
            <CompactRowSkeleton key={i} />
          ))}
        </div>
      </div>
    );
  }

  const layoutClass = view === 'list' ? 'menu-list' : 'menu-grid';
  const Card = view === 'list' ? ListCardSkeleton : GridCardSkeleton;

  return (
    <div className="menu-skeleton-body" aria-hidden>
      <div className={layoutClass}>
        {Array.from({ length: SKELETON_CARD_COUNT }, (_, i) => (
          <Card key={i} />
        ))}
      </div>
    </div>
  );
}

/**
 * @param {{ view?: 'grid' | 'list' | 'compact' | 'color-grid', part?: 'filters' | 'body' | 'full' }} props
 */
export default function OurMenuLoadingSkeleton({ view = 'grid', part = 'full' }) {
  if (part === 'filters' || part === 'overview') return <FilterSkeleton />;
  if (part === 'body') return <MenuBodySkeleton view={view === 'color-grid' ? 'grid' : view} />;

  return (
    <>
      <FilterSkeleton />
      <MenuBodySkeleton view={view === 'color-grid' ? 'grid' : view} />
    </>
  );
}

export { FilterSkeleton, MenuBodySkeleton };
